import { FieldDomainEnum } from 'packages/sdks-next/growp'
import { createContext, useContext } from 'react'

export const ListContext = createContext<{
  domain: FieldDomainEnum
  selectedRowKeys: number[]
  showExport: () => void
  clearRowKeys: () => void
}>({
  domain: FieldDomainEnum.InformalStudent,
  selectedRowKeys: [],
  showExport: () => null,
  clearRowKeys: () => null,
})

export function useListContext() {
  const context = useContext(ListContext)
  if (!context) {
    throw new Error('AnswersContext not exsist')
  }
  return context
}
